import React from 'react';
import { AutoConfirmedAlert, withLoading } from '@adjust/dashboard-components';
import { connectWithStore } from '@react/Common/connectWithStore';
import { SidebarId } from '@react/constants/sidebars';
import { closeAlert, getUserPermissionsState } from '@redux/ducks/userPermissions/userPermissions';
import { TraceStatus } from '@redux/types';
import { SidebarTitle } from './SidebarHeader';
import { UserPermissionForm } from './UserPermissionForm';

const UserPermissionsPageComponent = ({ user, isAlertOpen, trace, onCancel, onSubmit, closeAlert }) => (
  <div className="content content-panel flex-one flex-box-column">
    <SidebarTitle />
    <div className="sidebar-view flex-one flex-box-column">
      <div className="content content-panel content-setup flex-one flex-box-row relative">
        <div className="flex-one flex-box-column">
          <div className="content-inner flex-one flex-box-column">
            <div className="panel-content flex-one flex-box-column">
              {user?.super_admin ? (
                <div className="panel-section">
                  <div className="role-tag super-admin">{t('users.permissions.super-admin')}</div>
                  <p className="info">{t('users.permissions.super-admin.message')}</p>
                </div>
              ) : (
                <>
                  <UserPermissionForm onCancel={onCancel} onSubmit={onSubmit} />
                  <AutoConfirmedAlert
                    parentSidebarId={SidebarId.UserPermissions}
                    isOpen={isAlertOpen}
                    type={trace.status}
                    message={trace.message}
                    onConfirm={trace.status === TraceStatus.Error ? closeAlert : onCancel}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const UserPermissionsPageWithLoading = withLoading(UserPermissionsPageComponent, true);

const mapStateToProps = state => {
  const { user, isLoading, isAlertOpen, trace } = getUserPermissionsState(state);
  return { user, isLoading, isAlertOpen, trace };
};

const mapStateToDispatch = {
  closeAlert,
};

export const UserPermissionsPage = connectWithStore(
  mapStateToProps,
  mapStateToDispatch,
)(UserPermissionsPageWithLoading);
